import { call, put, select, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { HOME_ROOT, PAGES_ROOT } from 'config/api';
import plaidActions from './actions';
import workflowActions from '../workflow/actions';

function* updateMeta({ payload }) {
  const { page, ui } = yield select();
  try {
    yield call(payload.request(page.name, ui.activeGroup));
    yield put(plaidActions.updateMetaDone());
  } catch (e) {
    yield put(plaidActions.updateMetaDone());
  }
}

function* linkVerification({ payload }) {
  const { page, ui } = yield select();
  try {
    yield call(payload.request(page.name, ui.activeGroup));
    yield put(plaidActions.linkVerificationSuccess());
    payload.plaid.open();
  } catch (e) {
    const {
      response: { data },
    } = e;
    yield put(plaidActions.linkVerificationFailed(data));
    if (payload.callback) {
      payload.callback();
    }
  }
}

function* fetchAccounts({ payload }) {
  const { page, ui } = yield select();
  try {
    const fundingEndpoint = payload.refetch ? 'changeFundingAccount' : 'getAccounts';
    const method = payload.refetch ? 'GET' : 'POST';
    const url =
      page.name === 'home'
        ? `${HOME_ROOT}/${payload.requestId}/verifyPlaidSameDayDeposits`
        : `${PAGES_ROOT}/${page.name}/groups/${ui.activeGroup}/actions/${fundingEndpoint}`;
    const response = yield call(() =>
      axios({
        data: { ...payload.metadata },
        method,
        url,
      }),
    );
    const { data } = response;
    if (payload.plaidRef) {
      payload.plaidRef.open();
    } else if (page.name === 'home') {
      yield put(
        workflowActions.restart({
          appRequestId: payload.requestId,
          ddaAutoExportRequired: true,
        }),
      );
    } else {
      yield put(plaidActions.fetchAccountsSuccess(data));
    }
  } catch (e) {
    const {
      response: { data },
    } = e;
    yield put(plaidActions.fetchAccountsFailed(data));
  }
  if (payload.callback) {
    payload.callback();
  }
}

export default [
  takeEvery(plaidActions.FETCH_ACCOUNTS, fetchAccounts),
  takeEvery(plaidActions.LINK_VERIFICATION, linkVerification),
  takeEvery(plaidActions.UPDATE_META, updateMeta),
  takeEvery(plaidActions.REFETCH_ACCOUNTS, fetchAccounts),
];
